var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.GetResponsiveClass,attrs:{"id":"admin-navigation"}},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"item",class:{ ['selected']: _vm.selected === index },on:{"click":function($event){return _vm.OnItemClick(item)}}},[_c('span',[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }